//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PowerOffConfirmation from '../../helpers/component/power-off-comfirmation/index.vue';

export default {
  name: 'UnAuthHeader',
  components: {
    PowerOffConfirmation,
  },
  data() {
    return {
      isPowerDialog: false,
      helpOpen: false,
    };
  },
  methods: {
    powerOffDialog() {
      this.isPowerDialog = true;
    },
    cancelPowerDialog(value) {
      this.isPowerDialog = value;
    },
    gotoHelpPage() {
      this.helpOpen = true;
      this.$router.push('/boot-help');
    },
    closeHelpPage() {
      this.helpOpen = false;
      this.$router.push('/login');
    },
  },
};
